import { resolveStagedPreviewBackendUrl } from "@lib/util/staged-preview"

export type NewsletterSubscriptionInput = {
  email: string
  hcaptchaToken: string
  company: string
}

export type NewsletterSubscriptionResponse = {
  message: string
}

const backendUrl = () => {
  const value = resolveStagedPreviewBackendUrl(process.env.NEXT_PUBLIC_MEDUSA_BACKEND_URL)
  if (!value) throw new Error("Newsletter servisi yapılandırılmamış.")
  return value.replace(/\/+$/, "")
}

const publishableKey = () => {
  const value = process.env.NEXT_PUBLIC_MEDUSA_PUBLISHABLE_KEY?.trim()
  if (!value) throw new Error("Newsletter servisi yapılandırılmamış.")
  return value
}

const responseMessage = async (response: Response) => {
  try {
    const body = await response.json() as { message?: unknown }
    return typeof body.message === "string" && body.message.trim()
      ? body.message.trim()
      : null
  } catch {
    return null
  }
}

export async function subscribeNewsletter(
  input: NewsletterSubscriptionInput
): Promise<NewsletterSubscriptionResponse> {
  const response = await fetch(`${backendUrl()}/store/newsletter-subscriptions`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-publishable-api-key": publishableKey(),
    },
    body: JSON.stringify({
      email: input.email.trim().toLowerCase(),
      hcaptcha_token: input.hcaptchaToken,
      company: input.company,
    }),
  })

  const message = await responseMessage(response)
  if (!response.ok) {
    throw new Error(message ?? "Abonelik isteği gönderilemedi. Lütfen tekrar deneyin.")
  }

  return { message: message ?? "Aboneliğiniz alındı." }
}
